export default "__VITE_ASSET__n3v_cd7$__"